export default function SidebarHeader() {
    return (
        <div className="flex items-center justify-between flex-shrink-0 p-2">
            <span className="flex flex-col gap-1 p-2 text-xl font-semibold leading-8 tracking-wider whitespace-nowrap bg-[#f5f8fa] dark:bg-[#333333] rounded-2xl mt-14">
                <img src="/assets/img/logos/logo.png" className="w-full p-3" />
                {/* <span className="mr-2">bodoroj</span> */}
            </span>
        </div>
    )
}